import { Button, ButtonGroup } from "@chakra-ui/button";
import { Card, CardBody, CardFooter } from "@chakra-ui/card";
import { Image } from "@chakra-ui/image";
import { Divider, Heading, Stack, Text } from "@chakra-ui/layout";
import React from "react";

const UserJobListCard = ({ companyName, position, contract, location }) => {
  return (
    <Card maxW="sm" h={"100%"}>
      <CardBody>
        <Image
          boxSize={"60%"}
          m="auto"
          objectFit={"contain"}
          src="https://assets-news.housing.com/news/wp-content/uploads/2020/03/16121312/shutterstock_166852532.png"
          alt="it company"
          borderRadius="lg"
        />
        <Stack  spacing="3">
          <Heading size="md">Company Name: {companyName}</Heading>

          <Text>Position: {position}</Text>
          <Text color="blue.900" fontSize="md">
            WorkMode: {contract}
          </Text>
          <Divider></Divider>
          <Heading size="sm" color="blue.600">
           Location:  {location}
          </Heading>
        </Stack>
      </CardBody>
      <CardFooter mt='6'>
        <ButtonGroup spacing='2'>
        <Button variant='solid' colorScheme='blue'>
          Apply now
        </Button>
        
      </ButtonGroup>
      </CardFooter>
    </Card>
  );
};

export default UserJobListCard;
